import React, { CSSProperties } from 'react'
import styles from './loading.module.scss';

interface IProps {
    styleProps?: CSSProperties
}
const Loading: React.FC<IProps> = ({ styleProps }) => {
    return (
        <div className={styles.box} style={styleProps}>
            <span className={styles.mr}>mr. </span>
            <span className={styles.byte}>Byte's</span>
            <p className={styles.bgText}>menu</p>
        </div>
    )
}

export default Loading
